<div [formGroup]="formGroup">
  <input type="number" [formControlName]="field.name" [id]="field.name" />
</div>
